module.exports = __webpack_public_path__ + "static/media/circles.dc952e47.svg";